export interface IPItemReview {
  // DB Field
  uid: number;
  projectUID: number;
  containerUID: number;
  // itemUID: number;
  isMeeting: boolean; // 면담 사진 여부
  fileName: string;
  review: string;

  // NOT DB
  base64: string;
}

export const initializeIPItemReview: IPItemReview = {
  uid: 0,
  projectUID: 0,
  containerUID: 0,
  isMeeting: false,
  // itemUID: 0,
  fileName: "",
  review: "",
  base64: "",
}

// note 2022-03-01 SmokingScully 추가
export interface ItemReviewRequest {
  userToken: string;
  item: IPItemReview;
  successHandler?: any;
  failHandler?: any;
}

export interface ItemReviewDeleteRequest {
  userToken: string;
  id: number;
  successHandler?: any;
}